import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

function formatRupiah(n) { return 'Rp ' + n.toLocaleString('id-ID'); }

export default function CartPage() {
  const { cart, removeItem, updateQty, totalPrice, totalItems, clearCart } = useCart();
  const navigate = useNavigate();

  if (cart.length === 0) return (
    <div className="empty-state page-enter">
      <span className="empty-icon">🛒</span>
      <p>Keranjang belanja kamu kosong</p>
      <Link to="/" className="btn btn-primary">Mulai Belanja</Link>
    </div>
  );

  return (
    <div className="page-enter">
      <div className="page-title">Keranjang</div>
      <div className="two-col">
        <div className="section-box">
          <div className="sec-title">// item dipilih — {totalItems} produk</div>
          {cart.map(item => (
            <div key={item.productId} className="cart-item">
              <div className="cart-thumb">
                {item.image ? <img src={item.image} alt={item.name} /> : '🛍️'}
              </div>
              <div className="cart-info">
                <div className="cart-name">{item.name}</div>
                <div className="cart-price">{formatRupiah(item.price)} / item</div>
                <div className="cart-sub">{formatRupiah(item.price * item.quantity)}</div>
              </div>
              <div className="qty-ctrl">
                <button className="qty-btn" onClick={() => updateQty(item.productId, item.quantity - 1)}>−</button>
                <span className="qty-num">{item.quantity}</span>
                <button className="qty-btn" onClick={() => updateQty(item.productId, item.quantity + 1)} disabled={item.quantity >= item.stock}>+</button>
              </div>
              <button className="btn btn-danger" style={{ padding: '8px 10px' }} onClick={() => removeItem(item.productId)}>🗑</button>
            </div>
          ))}
          <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
            <button className="btn btn-secondary" onClick={clearCart}>Kosongkan</button>
            <Link to="/" className="btn btn-secondary">← Lanjut Belanja</Link>
          </div>
        </div>

        <div className="section-box">
          <div className="sec-title">// ringkasan</div>
          {cart.map(item => (
            <div key={item.productId} className="sum-row">
              <span style={{ fontSize: '0.83rem' }}>{item.name} ×{item.quantity}</span>
              <span style={{ fontFamily: 'var(--mono)', fontSize: '0.83rem' }}>{formatRupiah(item.price * item.quantity)}</span>
            </div>
          ))}
          <div className="sum-row">
            <span>Total ({totalItems} item)</span>
            <span>{formatRupiah(totalPrice)}</span>
          </div>
          <button className="btn btn-primary btn-full" style={{ marginTop: 20 }} onClick={() => navigate('/checkout')}>
            Checkout →
          </button>
        </div>
      </div>
    </div>
  );
}
